module.exports = __webpack_public_path__ + "static/img/list-icon-month.5fda022.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/vip/list-icon-month.png
// module id = yMsH
// module chunks = 0 1 2 3 4 5 6